import { render, staticRenderFns } from "./basiccontrol.vue?vue&type=template&id=de903ab2&scoped=true&"
import script from "./basiccontrol.vue?vue&type=script&lang=js&"
export * from "./basiccontrol.vue?vue&type=script&lang=js&"
import style0 from "./basiccontrol.vue?vue&type=style&index=0&id=de903ab2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de903ab2",
  null
  
)

export default component.exports